import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import Footer from '@/components/common/Footer';

export function AppLayout() {
  return (
    <div className="app-shell" data-theme="swayam-preview">
      <Sidebar />
      <div className="app-content-shell">
        <Header />
        <main className="app-main">
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
}
